module.exports = __webpack_public_path__ + "img/up_res_service.f8c9adf1.svg";